module.exports = {
  mapbox:
   'pk.eyJ1IjoianVhbmlyYWNoZSIsImEiOiJjbDAwMGN5YXQwZmN2M2lwNnlzY2xsYXNrIn0.nnmLYD4EOUMbk1QH3DtShA'
};

